export default __webpack_public_path__ + "static/media/DORA.3e713759.jpg";